/*
 * ===============================================================================================================
 *                                Copyright 2024, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
import { makeStyles } from "@mui/styles";
import { Info } from "@jda/lui-common-icon-library-mui5";
import { IconButton, Theme, Tooltip } from "@mui/material";

const useStyles = makeStyles((theme: Theme) => ({
  tooltip: {
    textAlign: "left",
    maxWidth: theme.spacing(50),
  },
}));

export const CustomTooltip = (props: { title: string; placement?: any }) => {
  const classes = useStyles();
  return (
    <Tooltip
      arrow
      classes={{ tooltip: classes.tooltip }}
      placement={props.placement ?? "top-start"}
      title={<pre style={{ whiteSpace: "pre-line" }}>{props.title}</pre>}
    >
      <IconButton size="small">
        <Info fontSize="small" />
      </IconButton>
    </Tooltip>
  );
};
